<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps<{
    words: string[]
}>()

const { words } = props

const active = ref(0)
let intervalId: number | undefined

const mounted = ref(false)
onMounted(() => {
    mounted.value = true

    setInterval(() => {
        if (active.value === words.length - 1) {
            active.value = 0
        } else {
            active.value++
        }
    }, 5000)
})
onUnmounted(() => {
    if (intervalId !== undefined) clearInterval(intervalId)
})
</script>

<template>
    <span
        v-if="mounted"
        class="text-slide-wrapper text-center"
    >
        <span
            v-for="(word, index) in words"
            :key="index"
            :class="{ 'is-inactive': active !== index, 'is-active': active === index }"
            class="text-slide-item"
        >
            <span v-if="index !== 0">&nbsp;</span>{{ word }}
        </span>
    </span>
    <span v-else>{{ words.join(' ') }}</span>
</template>

<style lang="scss" scoped>
.text-slide-wrapper {
    position: relative;
    display: inline-flex;
    overflow: hidden;

    .text-slide-item {
        display: inline-block;
        position: absolute;
        white-space: nowrap;
        left: 0;
        top: 0;
        padding: 0 5px;
        opacity: 0;

        &.is-active {
            position: relative;
            opacity: 1;
            -webkit-animation: push-in 1s;
            -moz-animation: push-in 1s;
            animation: push-in 1s;
        }

        &.is-inactive {
            -webkit-animation: push-out 1s;
            -moz-animation: push-out 1s;
            animation: push-out 1s;
        }
    }
}

@keyframes push-in {
    0% {
        opacity: 0;
        -webkit-transform: translateY(100%);
        -moz-transform: translateY(100%);
        -ms-transform: translateY(100%);
        -o-transform: translateY(100%);
        transform: translateY(100%);
    }
    100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
    }
}
@keyframes push-out {
    0% {
        opacity: 1;
        -webkit-transform: translateY(0);
        -moz-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        -webkit-transform: translateY(-100%);
        -moz-transform: translateY(-100%);
        -ms-transform: translateY(-100%);
        -o-transform: translateY(-100%);
        transform: translateY(-100%);
    }
}
</style>
